import Dialog from '@/components/Dialog'
import IcoMoon from '@/components/IcoMoon'
import { useTranslation } from 'next-i18next'
import * as styles from './style'

export default function AccessRestrictedDialog(): JSX.Element {
  const { t } = useTranslation('common')

  return (
    <Dialog customClass={styles.customClass}>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <IcoMoon icon="lock" size={64} />
        </div>
        <h1 className={`${styles.heading} mt-5 font-bold`}>{t('accessRestricted.title')} </h1>
        <h3 className={`${styles.subheading} text-center mt-2`}>{t('accessRestricted.subtitle')}</h3>
      </div>
    </Dialog>
  )
}
